__webpack_require__.p = "/terraAPI-hackathon-app/";